var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnekeyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 13.333333969116211,
    height: 13.456003189086914,
    viewBox: "0 0 13.333333969116211 13.456003189086914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.69733,6.89309Q2.31025,5.81219,1.02248,6.58485Q-0.351313,7.40912,0.120708,8.49706C0.147428,8.55864,0.18306,8.61646,0.221775,8.67131L3.20079,12.8916C3.45062,13.2455,3.85685,13.456,4.29008,13.456L12,13.456C12.7364,13.456,13.3333,12.859,13.3333,12.1227L13.3333,7.48757C13.3333,6.94236,13.0014,6.45208,12.4952,6.2496L9.03883,4.86706L9.03883,2.00409Q8.75253,0,7.03474,0Q5.31696,0,5.03066,2.00409L5.03066,6.30068L5.03066,8.30264L4.00817,7.15745Q3.85213,7.01373,3.69733,6.89309ZM3.0598,8.09723Q2.59005,7.6764,2.23352,7.60802Q1.9874,7.56082,1.70847,7.72818Q1.45903,7.87784,1.36435,7.97788L4.29008,12.1227L12,12.1227L12,7.48757L8.54365,6.10504C8.03743,5.90255,7.7055,5.41227,7.7055,4.86706L7.7055,2.10588Q7.6238,1.61578,7.45185,1.44383Q7.34135,1.33333,7.03474,1.33333Q6.72814,1.33333,6.61764,1.44383Q6.44569,1.61578,6.36399,2.10589L6.36399,8.30264C6.36399,9.03902,5.76704,9.63597,5.03066,9.63597C4.65084,9.63597,4.28904,9.47398,4.03607,9.19066L3.0598,8.09723Z",
    fillRule: "evenodd",
    fill: "#27314D",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnekeyBlack);
export default __webpack_public_path__ + "static/media/onekey_black.789d12ea32870fdfa37abb057d622480.svg";
export { ForwardRef as ReactComponent };